import { isArray, isNil, isObject } from 'lodash';
import { ReformedPermissions } from '../../components/permissionRoles/type';
import actions, { Actions } from '../../constants/actions';
import { cleanPermissionAttributes as cleanReportPermissionAttributes } from '../reports/permissions';

const cleanItem = (value: any) => {
  if (isNil(value) || value === '') {
    return undefined;
  }

  if (isObject(value)) {
    if (Object.keys(value).length === 0 || Object.values(value).every((item) => isNil(item) || item === '')) {
      return undefined;
    }
  }
  return value;
};

const cleaner = (data: any) => JSON.parse(JSON.stringify(data, (key, value) => {
  if (isNil(value) || value === '') return undefined;

  if (isObject(value) && !isArray(value)) {
    if (Object.keys(value).length === 0 || Object.values(value).every((item) => isNil(item) || item === '')) {
      return undefined;
    }
  }

  if (isArray(value)) {
    const cleanedArray = value
      .map((item) => cleanItem(item))
      .filter((item) => !!item);
    // if (cleanedArray.length === 0) return undefined;
    return cleanedArray;
  }

  return value;
}));

export const memberCleaner = (data: any) => ({
  firstName: data.firstName,
  lastName: data.lastName,
  email: data.email,
  permissionRoleIds: data.permissionRoleIds,
  occupation: data.occupation,
  birthDate: data.birthDate,
  swedishSocialSecurityNumber: data.swedishSocialSecurityNumber,
  residence: data.residence,
  foreignId: data.foreignId,
  foreignIdCountry: data.foreignIdCountry,
  teams: data.teams,
});

type PermissionValue = NonNullable<ReformedPermissions[Actions]>;
type PermissionAttributesCleaner = (value: PermissionValue) => unknown;

const permissionAttributesCleaners: Partial<Record<Actions, PermissionAttributesCleaner>> = {
  [actions.REPORT_GET]: cleanReportPermissionAttributes,
  [actions.REPORT_LIST]: cleanReportPermissionAttributes,
  [actions.REPORT_CREATE]: cleanReportPermissionAttributes,
  [actions.REPORT_DOWNLOAD]: cleanReportPermissionAttributes,
};

const noopAttributesCleaner = (value: { attributes: unknown }) => value.attributes;
export const permissionRoleCleaner = (data: any) => JSON.parse(
  JSON.stringify(data, (key, value) => {
    if (key === 'permissions') {
      const typedValue = value as ReformedPermissions;
      return Object.entries(typedValue)
        .filter((val) => val[1].enabled)
        .map((val) => {
          const permissionAttributesCleaner = permissionAttributesCleaners[val[0] as Actions]
            ?? noopAttributesCleaner;
          const cleanedAttributes = permissionAttributesCleaner(val[1]);
          if (cleanedAttributes !== undefined) {
            return { name: val[0], attributes: cleanedAttributes };
          }
          return { name: val[0] };
        });
    }

    return value;
  }),
);

export const apiKeyCleaner = (data: any) => ({
  permissionRoleIds: data.permissionRoleIds,
});

export const entityCleaner = (data: any) => JSON.parse(JSON.stringify(data, (key, value) => {
  if (isNil(value) || value === '') return undefined;

  if (key === 'customId') return undefined;

  if (key === 'groups') return value;

  if (isObject(value)) {
    if (Object.keys(value).length === 0 || Object.values(value).every((item) => isNil(item) || item === '')) {
      return undefined;
    }
  }

  if (isArray(value)) {
    const cleanedArray = value
      .map((item) => cleanItem(item))
      .filter((item) => !!item);
    if (cleanedArray.length === 0) return undefined;
    return cleanedArray;
  }

  return value;
}));

export default cleaner;
